import { useContext } from 'react';
import { ChatSessionsContext } from './chatSessionsContext';

export function useChatSessions() {
  const context = useContext(ChatSessionsContext);

  if (context === null) {
    throw new Error('useChatSessions must be used within ChatSessionsProvider');
  }

  return context;
}
